var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzurePipelines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_15457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.768 56.9152L39.0848 63.232H49.3376C50.5856 63.232 51.5904 62.2144 51.5904 60.9792V37.2992L32.768 56.128C32.544 56.3392 32.544 56.6912 32.768 56.9152Z",
    fill: "#315DA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6848 30.5856V40.8384L23.0016 47.1552C23.2256 47.3792 23.5712 47.3792 23.7824 47.1552L42.624 28.32H18.944C17.7024 28.32 16.6848 29.3376 16.6848 30.5856Z",
    fill: "#416CB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3904 19.104L25.184 42.368C24.672 43.1616 24.7744 44.1984 25.44 44.864L35.1808 54.6048C35.8464 55.2704 36.896 55.3728 37.6768 54.8608L60.9408 39.648C62.4256 38.6816 63.3088 37.0176 63.3088 35.2576V19.0336C63.3088 17.76 62.272 16.7232 60.9984 16.7232H44.7936C43.0208 16.7232 41.3696 17.6192 40.3904 19.104Z",
    fill: "#6289C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1088 60.032V51.808H16.6848V63.2768H28.3264V60.032H20.1088Z",
    fill: "#A0B9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.648 33.952C54.848 33.952 57.44 31.36 57.44 28.16C57.44 24.96 54.8416 22.368 51.648 22.368C48.448 22.368 45.856 24.96 45.856 28.16C45.856 31.36 48.448 33.952 51.648 33.952Z",
    fill: "#AFC4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2772 35.9215L28.8911 48.3076L31.7467 51.1632L44.1328 38.7771L41.2772 35.9215Z",
    fill: "#7296CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.889 48.3114L26.4272 50.7732L29.2827 53.6288L31.7445 51.1669L28.889 48.3114Z",
    fill: "#8BAAD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_15457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurePipelines);
export default __webpack_public_path__ + "static/media/azure-pipelines.18a1d85c2dcbbf91196935d5936aa06b.svg";
export { ForwardRef as ReactComponent };